import { ValueState } from '@ui5/webcomponents-react';
import validator from 'validator';

export const validateDeadline = (
  setValueState: (valueState: ValueState) => void,
  value: string,
  valid: boolean
): boolean => {
  if (value && valid) {
    setValueState(ValueState.Success);
    return true;
  }

  setValueState(ValueState.Error);
  return false;
};

export const validateString = (
  value: string,
  setValueState: (valueState: ValueState) => void,
  invalidState: ValueState = ValueState.Error,
  validState: ValueState = ValueState.Success
): boolean => {
  if (value && value.trim() !== '') {
    setValueState(validState);
    return true;
  } else {
    setValueState(invalidState);
    return false;
  }
};

export const validateTwoDifferentStrings = (
  value: string,
  value2: string,
  setValueState: (valueState: ValueState) => void
): boolean => {
  if (value !== value2) {
    setValueState(ValueState.Success);
    return true;
  } else {
    setValueState(ValueState.Error);
    return false;
  }
};

export const validateProject = (
  value: string,
  setValueState: (valueState: ValueState) => void
): boolean => {
  if (value === '-1') {
    setValueState(ValueState.Error);
    return false;
  }
  setValueState(ValueState.Success);
  return true;
};

export const validateAssigneeEmail = (
  queryAssignee: string,
  value: string,
  setValueState: (valueState: ValueState) => void
): boolean => {
  if (validator.isEmail(value) || (queryAssignee === '' && value === '')) {
    setValueState(ValueState.Success);
    return true;
  } else {
    setValueState(ValueState.Error);
    return false;
  }
};

export const validateEmail = (
  value: string,
  setValueState?: (valueState: ValueState) => void
): boolean => {
  const isValid = value !== '' && validator.isEmail(value);
  if (setValueState) {
    setValueState(isValid ? ValueState.Success : ValueState.Error);
  }
  return isValid;
};

export const validateFieldLength = (
  value: string,
  length: number,
  setValueState: (valueState: ValueState) => void
): boolean => {
  if (value.length === 0 || value.length >= length) {
    setValueState(ValueState.None);
    return true;
  }
  setValueState(ValueState.Error);
  return false;
};

export const validateSAPUserId = (
  userId: string,
  setValueState: (valueState: ValueState) => void
): boolean => {
  const pattern = /^(C[0-9]{7}|[DI][0-9]{6})$/i;
  const result = pattern.test(userId);
  setValueState(result ? ValueState.Success : ValueState.Error);
  return result;
};
